import type { Dayjs } from 'dayjs';
import type { Application } from '../../../types';
import type { RegisterEdoDispatchBody } from '../types';
import { trimOptionalComment } from './commentPolicy';
import { validateTaskModalEventDate } from './taskModalValidation';

export type SendViaEdoValidationIssue = {
  code: 'EVENT_DATE_REQUIRED' | 'RECIPIENT_REQUIRED';
  message: string;
};

export function buildDefaultEdoRecipient(application: Application | null | undefined): string {
  const clientName = application?.client?.name?.trim();
  const consigneeName = application?.consignee?.name?.trim();
  return clientName || consigneeName || 'Клиент';
}

export function validateSendViaEdoSubmit(input: {
  dispatchedAt: Dayjs | null | undefined;
  comment: string | null | undefined;
}): SendViaEdoValidationIssue | null {
  return validateTaskModalEventDate(
    input.dispatchedAt,
    'Укажите дату отправки через ЭДО'
  ) as SendViaEdoValidationIssue | null;
}

export function buildEdoDispatchBody(input: {
  recipient: string;
  comment: string | null | undefined;
  dispatchedAt: string;
}): RegisterEdoDispatchBody {
  const body: RegisterEdoDispatchBody = {
    recipient: input.recipient.trim(),
    dispatchedAt: input.dispatchedAt,
  };
  const trimmedComment = trimOptionalComment(input.comment);
  if (trimmedComment) {
    body.comment = trimmedComment;
  }
  return body;
}
